import React, { FC } from 'react';
import { TSeriesListingProps } from './types/seriesListing.types';
import ProductCard from './components/productCard';
import { SeriesListingModel } from './models/seriesListing.model';
import '../../../styles/@shared/product-card-dashboard.scss';
import './styles.scss';
import { isEditorActive, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { isEmptyResponse } from '../../../utils/checkEmptyResponse';
import useExperienceEditorPlaceholder from '../../../hooks/useExperienceEditorPlaceholder';
import { ComponentConsumerProps, WithSitecoreContextProps } from '@sitecore-jss/sitecore-jss-react/types/enhancers/withSitecoreContext';
import { googleLineSeriesClick } from '../../../utils/analytics';
import { appendToUrlPath } from '../../../utils/link.utils';
import { lineSeriesClick } from '../../../constants/analytics.constants';
import useSitecoreContext from '../../../hooks/useSitecoreContext';

const SeriesListing: FC<Partial<WithSitecoreContextProps> & TSeriesListingProps & ComponentConsumerProps> = (props) => {
  const model = new SeriesListingModel(props);
  const apiResponse = isEmptyResponse(props) && props?.fields?.apiData?.items && props?.fields?.apiData?.items?.length > 0;
  const isPlaceholderShown = useExperienceEditorPlaceholder(props);
  const {sitecoreContext} = useSitecoreContext();
  const productLine = sitecoreContext?.analytics?.['productLine'] ? sitecoreContext?.analytics?.['productLine'] : undefined;

  // No data and not in EE
  if (!apiResponse && !isPlaceholderShown && !isEditorActive()) {
    return null;
  }

  return (
    <>
      <div className="series-listing product-card-dashboard__wrapper">
        <div className="product-card-dashboard">
          <section className="product-card-dashboard__products">
            {model?.items?.map((productCard, ind) => {
              const onAnimateProps = props.shouldAnimate
                ? {
                    shouldAnimate: props.shouldAnimate,
                    animationDelay: `${(ind + 1) * 0.05}s`,
                  }
                : {};
              return (
                <ProductCard
                  {...productCard}
                  thumbnailAlt={productCard?.assets?.[0]?.alt}
                  bodyTextVisibility={model.bodyTextVisibility}
                  baseUrl={model.baseUrl}
                  key={productCard.id}
                  onclick={() => {
                    googleLineSeriesClick(
                      lineSeriesClick,
                      productLine,
                      productCard?.title,
                      productCard?.title,
                      appendToUrlPath(model?.baseUrl || '', productCard?.titleUrl || '')
                    );
                  }}
                  {...onAnimateProps}
                />
              );
            })}
          </section>
        </div>
      </div>
    </>
  );
};

export default withSitecoreContext()(SeriesListing);
